export default __webpack_public_path__ + "static/media/hecho.915a4eb7.png";